import { FieldViewModel } from "../../../omnia"
import { getNutrientTypes } from "../../../utils"
import { INutritionMapViewContext } from "../types"
import { RequirementsMapView } from "./requirements"

/// <reference path="requirements.ts" />

export class ClosingRequirementsMapView extends RequirementsMapView {

    static create(ctxt: INutritionMapViewContext) {

        let views = getNutrientTypes().map(nutrientType => {

            let view = new ClosingRequirementsMapView("Closing requirements", "closing-req", nutrientType, ctxt);
            view.setup();
            return view;

        })

        return views;

    }

    protected createCroppingDatalayer(layerId: number, cropping: FieldViewModel, nutrientKey: string) {

        let requirements = this.ctxt.planReader.getClosingRequirements(cropping.croppingId) || [];
        requirements = requirements.filter(r => !r.Aggregate);
        requirements = this.filterNutrientGroup(requirements);

        if (requirements.length) {
            let datalayer = this.createVirtualLayer(layerId, cropping, requirements, nutrientKey);
            return datalayer;

        }
    }


}
